import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgSarmayeh = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#sarmayeh_svg__a)'>
      <path
        fill='#1C1561'
        fillRule='evenodd'
        d='M7.16 15.124V8.143C12.273 7.983 16.801 4.87 20.98 0L21 7.989c-4.613 5.339-9.227 7.05-13.84 7.135'
        clipRule='evenodd'
      />
      <path
        fill='#1C1561'
        d='M14.585 23.311c1.665-.38 2.697-1.998 2.304-3.613s-2.062-2.614-3.727-2.233-2.697 1.999-2.304 3.613 2.062 2.614 3.727 2.233'
      />
      <path
        fill='#B5B8B8'
        fillRule='evenodd'
        d='M16.84 8.666v6.98c-5.113.16-9.641 3.273-13.82 8.143L3 15.8c4.613-5.34 9.227-7.05 13.84-7.135'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='sarmayeh_svg__a'>
        <path fill='#fff' d='M0 .001h24v24H0z' />
      </clipPath>
    </defs>
  </svg>
)
const ForwardRef = forwardRef(SvgSarmayeh)
export default ForwardRef
